import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'src/app/app.constants';
import { AuthenticationService } from './authentication.service';
import { ZoneViewModel } from '../viewModels/zoneViewModel';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly configuration: Configuration,
    private readonly authenticationService: AuthenticationService
  ) {
    
  }

  /**
   * Getter that dynamically builds the baseUrl each time.
   * This ensures the URL updates when the backend API changes (e.g., account switching).
   */
  private get baseUrl(): string {
    return this.configuration.buildEndpoint(`Incident/`);
  }

  getZones() {
    return this.httpClient.get<ZoneViewModel[]>(
      this.baseUrl + `Nomenclatures/Zones`,
      this.authenticationService.getHttpOptions()
    );
  }
}
